import React from 'react';
import { useTranslation } from 'react-i18next';
import { SubmitFormValues } from '../../redux/types';
import FieldFormPopup from '../FieldFormPopup';
import { FieldFormPopupProps, FieldFormPopupState } from '../FieldFormPopup/types';
import LabelsForm from '../../common/LabelsForm';

const LabelsFormPopup: React.FC<
  FieldFormPopupProps & FieldFormPopupState<SubmitFormValues['labels']>
> = ({ currentValue, setValue, ...props }) => {
  const { t } = useTranslation();
  return (
    <FieldFormPopup
      {...props}
      heading={t('deviationSubmit.form.labels.list.heading')}
      subheading={t('deviationSubmit.form.labels.list.subheading')}
    >
      <LabelsForm currentValue={currentValue} setValue={setValue} />
    </FieldFormPopup>
  );
};
LabelsFormPopup.displayName = 'LabelsFormPopup';

export default LabelsFormPopup;
